import type { ResultOf } from "@graphql-typed-document-node/core";
import { ErrorADT, safe } from "pb.safe";

import { $, query } from "../../../../schema.dev-sdk-api-appsync.generated";
import type { ApiClient } from "../shared/shared/api-client";
import { transactionFields } from "./transaction-fields";

export type Transaction = Exclude<
	Awaited<ReturnType<typeof getTransaction>>,
	Error
>;

export async function getTransaction({
	apiClient,
	deviceId,
	transactionId,
}: {
	apiClient: ApiClient;
	deviceId: string;
	transactionId: string;
}): Promise<
	| ResultOf<typeof getTransaction.gql.getTransaction>["getTransaction"]
	| ErrorADT<"NetworkFailure">
> {
	const response = await safe(() =>
		apiClient.request(getTransaction.gql.getTransaction, {
			deviceUuid: deviceId,
			transactionUuid: transactionId,
		}),
	);
	if (response instanceof Error) {
		return ErrorADT("NetworkFailure");
	}
	return response.getTransaction;
}

getTransaction.gql = {
	getTransaction: query("getTransaction", (q) => [
		q.getTransaction(
			{ deviceUuid: $("deviceUuid"), transactionUuid: $("transactionUuid") },
			(t) => [...transactionFields(t)],
		),
	]),
};
